import { DesktopAPI } from '~/api/core'

const routineAPI = new DesktopAPI('/api/routines')

export default {
  list: params => routineAPI.get('', params),
}
